import React from 'react';
import { getImage } from '../../../../utils/imageHelper';
import moment from 'moment';
import styles from "../../cards.module.scss"

function newsListItem({ news, handleClicknews, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={() => handleClicknews(news)}>
      <img
        className={styles.projectImage}
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />

      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{news.title}</p>
          <span className={styles.subtitle}>
            {moment(news.creation_date).format('DD/MM/YYYY')}
          </span>
        </div>
      </div>
    </div >
  );
}

export default newsListItem;
